// 告警分类：挂在「每一条告警」上，回答"这是什么性质的问题"。
// 原始数据里的 严重故障/一般故障/告警 由后端映射为下面三档，前端只认这三档，不出现原始等级文案。
// 与「电站处理等级」(见 ./stationLevel.js 的 P0/P1/P2) 是两个正交维度：分类=业务影响，等级=处置优先级。
export const CATEGORY_META = {
  SAFETY: { code: 'SAFETY', name: '影响安全', label: '影响安全', icon: 'mdi-fire-alert' },
  INCOME: { code: 'INCOME', name: '影响收益', label: '影响收益', icon: 'mdi-lightbulb-alert-outline' },
  NORMAL: { code: 'NORMAL', name: '普通告警', label: '普通告警', icon: 'mdi-bell-alert-outline' },
}
// 严重程度排序（影响安全 > 影响收益 > 普通告警），用于电站取最高分类
export const CATEGORY_ORDER = { SAFETY: 0, INCOME: 1, NORMAL: 2 }
export const CATEGORY_KEYS = ['SAFETY', 'INCOME', 'NORMAL']

export function getCategoryInfo(category) {
  return CATEGORY_META[category] || CATEGORY_META.NORMAL
}
export function getCategoryLabel(category) {
  return getCategoryInfo(category).label
}
export function getCategoryClass(category) {
  return `cat-${(category || 'NORMAL').toLowerCase()}`
}
export function getCategoryIcon(category) {
  return getCategoryInfo(category).icon
}
